export default class Loader {
  targetEl;

  targetElPosition = 'beforeend';

  hideClass = 'd-none';

  injected;

  // a generated id, in case there are multiple loaders
  loaderId;

  _loaderElement;

  static className = 'loader-wrapper';

  // loader template
  element;

  constructor(options) {
    /* eslint-disable-next-line */
    this.loaderId = `loader--${Math.random()
      .toString(36)
      .substring(2, 9)}`;
    this.injected = false;
    const { className } = Loader;
    this.element = `
        <div id="${this.loaderId}" class="${className} ${this.hideClass} vh-100 vw-100">
          <div class="loader-logo">
            <svg xmlns="http://www.w3.org/2000/svg" height="142" width="60" viewBox="0 0 90 70">
              <g fill="none" fill-rule="evenodd">
                <path d="M59.164 28.039c-1.396.05-2.774.13-4.134.24 16.02 5.678 11.745 15.225-3.302 23.092-4.81 2.619-10.962 4.952-16.995 6.365 10.054 2.308 22.556 3.283 34.477 2.54l8.06-31.046c-5.541-.98-11.668-1.422-18.106-1.191" fill="#2DC490"></path>
                <path d="M63.432.592c-8.733.313-17.025 1.438-24.55 3.204C16.102 9.143.37 20.374.815 32.796c.076 2.122.623 4.175 1.59 6.141 1.806 3.668 5.08 7.027 9.515 9.947.589.388 1.195.77 1.823 1.14 2.584 1.528 5.503 2.92 8.705 4.155.655.253 1.326.497 2.005.737 6.446-1.27 12.307-3.283 17.162-5.742-9.376-2.905-15.987-7.594-17.747-13.176a9.94 9.94 0 01-.462-2.652c-.098-2.72.94-5.357 2.903-7.806 1.247-1.554 2.865-3.033 4.808-4.409 7.73-5.477 20.56-9.326 35.196-9.85 5.412-.195 10.607.087 15.42.761l2.737-10.539C77.86.663 70.783.328 63.432.593" fill="#1083FF"></path>
              </g>
            </svg>
          </div>
          <div class="loader"></div>
        </div>
    `;
    let targetSelector = 'body';
    if (options && options.targetElSelector) {
      targetSelector = options.targetElSelector;
    }
    try {
      this.targetEl = document.querySelector(targetSelector);
    } catch (e) {
      console.error('Invalid selector', e);
    }
  }

  inject() {
    if (this.targetEl) {
      this.injected = true;
      this.targetEl.insertAdjacentHTML(this.targetElPosition, this.element);
    }
  }

  show() {
    if (!this.injected) {
      this.inject();
    }
    this.injected = !this.injected;
    this.loaderElement().classList.remove(this.hideClass);
  }

  hide() {
    this.injected = !this.injected;
    const loaderElement = this.loaderElement();
    if (loaderElement) {
      this.loaderElement().classList.add(this.hideClass);
    }
  }

  loaderElement() {
    if (!this._loaderElement) {
      this._loaderElement = document.getElementById(this.loaderId);
    }
    return this._loaderElement;
  }

  /**
   * This method is required for clearing any loaders present in the page.
   * It is required due to a Safari behaviour where if the user pressed back (browser)
   * the loader would be visible on page load.
   */
  static clear() {
    const { className } = Loader;
    const loader = document.querySelector(`.${className}`);
    if (loader && loader.parentNode) {
      loader.parentNode.removeChild(loader);
    }
  }
}
